import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { GoalsHistory } from "../models/goals-history.model";
import { GroupGoal } from "../models/group-goal.model";
import { DataService } from "./data.service";
import { StateService } from "./state.service";
import { GroupGoalsPage } from "../models/group-goals-page.model";
import { GroupGoalsSaveModel } from "../models/group-goals-save.model";

@Injectable({
    providedIn: 'root',
})
export class GroupGoalService extends DataService {
    constructor(http: HttpClient, stateService: StateService) {
        super(http, stateService);
    }

    getGroupGoals(goalPeriodId: number): Observable<GroupGoalsPage>  {
        return this.get(`/api/group-goals/${goalPeriodId}`);
    }

    addGroupGoal(groupGoal: GroupGoal): Observable<GroupGoal> {
        return this.put(`/api/group-goals/add`, groupGoal);
    }
    
    updateGroupGoal(groupGoal: GroupGoal): Observable<any> {
        return this.post('/api/group-goals/update', groupGoal);
    }

    deleteGroupGoal(id: number): Observable<any> {
        return this.delete('/api/group-goals/delete/' + id);
    }

    getLeaderGroupGoals(goalPeriodId: number): Observable<GroupGoal[]> {
        return this.get(`/api/group-goals/leader-group-goals/${goalPeriodId}`);
    }

    getHistory(reviewPeriodId: number, employeeId: number): Observable<GoalsHistory>  {
        return this.get(`/api/group-goals/history/${reviewPeriodId}/${employeeId}`);
    }

    saveGroupGoals(model: GroupGoalsSaveModel): Observable<any> {
        return this.post('/api/group-goals/save', model);
    }
}